// @ts-ignore
import QrCodeWithLogo from 'qrcode-with-logos'
import {useEffect} from "react";
import {useInitData} from "@tma.js/sdk-react";
import {webappAddress} from "../../communication/communication";

export function QRCode() {
    const initData = useInitData()



    useEffect(() => {

        const id = initData!.user!.id
        const encoded = id.toString(36);

        let url = `https://${webappAddress}?startapp=${encoded}`

        const image = document.createElement("image") as HTMLImageElement;
        const canvas = document.getElementById("qr-canvas") as HTMLCanvasElement;
        new QrCodeWithLogo({
            canvas: canvas,
            content: url,
            width: 800,
            image: image,
            logo: {
                borderWidth: 160,
                src: process.env.PUBLIC_URL + '/qr-explyt-logo.png'
            }
        });
    }, [initData]);


    return <div className="small-margin small-margin-top">
        <div style={{backgroundColor: "white", borderRadius: "1rem", padding: "1rem", margin: "2rem"}}>
            <canvas id="qr-canvas" width={800} height={800} style={{height: "100%", width: "100%"}}></canvas>
        </div>
    </div>
}